var map = {
	"./App": 8075,
	"./App.vue": 8075,
	"./api/news": 73,
	"./api/news.js": 73,
	"./api/siteI18n": 4105,
	"./api/siteI18n.js": 4105,
	"./assets/AminoAcid/banner1.png": 6568,
	"./assets/AminoAcid/banner_title.png": 3318,
	"./assets/AminoAcid/module2_bg.png": 2203,
	"./assets/AminoAcid/module2_ele1.png": 5427,
	"./assets/AminoAcid/module2_ele2.png": 936,
	"./assets/AminoAcid/module2_ele3.png": 9201,
	"./assets/AminoAcid/module2_ele4.png": 3086,
	"./assets/AminoAcid/module2_ele5.png": 6103,
	"./assets/AminoAcid/module3_bg.jpeg": 5701,
	"./assets/Application/electric.png": 1927,
	"./assets/Application/farm.png": 2042,
	"./assets/Application/package.png": 660,
	"./assets/Application/pig.png": 3624,
	"./assets/Application/toy.png": 4699,
	"./assets/BioIntelligent/Industry.png": 5921,
	"./assets/BioIntelligent/Laboratory.png": 5960,
	"./assets/BioIntelligent/aminoacidsynthesis.jfif": 8364,
	"./assets/BioIntelligent/banner_img.png": 6117,
	"./assets/BioIntelligent/banner_title.png": 7066,
	"./assets/BioIntelligent/component_1.png": 770,
	"./assets/BioIntelligent/component_2.png": 5385,
	"./assets/BioIntelligent/component_3.png": 7264,
	"./assets/BioIntelligent/component_title.png": 3529,
	"./assets/BioIntelligent/customsolution.png": 6839,
	"./assets/BioIntelligent/flow.png": 4219,
	"./assets/BioIntelligent/hangzhou.jfif": 5881,
	"./assets/BioIntelligent/jiande.jfif": 5010,
	"./assets/BioIntelligent/module1_bg.jpeg": 7543,
	"./assets/BioIntelligent/nanyang.jfif": 1420,
	"./assets/BioIntelligent/newmaterial.png": 2234,
	"./assets/BioIntelligent/part4.png": 7762,
	"./assets/BioIntelligent/productsolution.jfif": 2843,
	"./assets/BioIntelligent/swipper1.png": 5904,
	"./assets/BioIntelligent/swipper2.png": 4235,
	"./assets/BioIntelligent/swipper3.png": 9410,
	"./assets/CorporateVision/corp1.png": 8106,
	"./assets/CorporateVision/corp2.png": 9217,
	"./assets/CorporateVision/corp3.png": 9000,
	"./assets/CorporateVision/corp4.png": 8615,
	"./assets/CorporateVision/corp5.png": 6126,
	"./assets/CorporateVision/corp6.png": 8229,
	"./assets/CorporateVision/corp7.png": 5964,
	"./assets/CorporateVision/corp8.png": 5851,
	"./assets/KnotWeed/banner1.jpeg": 5817,
	"./assets/NewMaterial/P001-1.png": 7904,
	"./assets/NewMaterial/P001-2.jpeg": 236,
	"./assets/NewMaterial/P001-3.jpeg": 5539,
	"./assets/NewMaterial/P002-1.jpeg": 228,
	"./assets/NewMaterial/P002-2.jpeg": 5733,
	"./assets/NewMaterial/P002-3.jpeg": 5470,
	"./assets/NewMaterial/P002-new.jpg": 7408,
	"./assets/NewMaterial/P003-1.jpeg": 2039,
	"./assets/NewMaterial/P003-2.png": 2421,
	"./assets/NewMaterial/P003-3.png": 3004,
	"./assets/NewMaterial/P003-4.png": 2963,
	"./assets/NewMaterial/P003-5.png": 7754,
	"./assets/NewMaterial/P003-6.png": 6737,
	"./assets/NewMaterial/P004-1.jpeg": 7094,
	"./assets/NewMaterial/P004-2.png": 4002,
	"./assets/NewMaterial/P004-3.png": 4507,
	"./assets/NewMaterial/P004-4.jpg": 320,
	"./assets/NewMaterial/P005-1.jpg": 1624,
	"./assets/NewMaterial/P005-2.png": 6535,
	"./assets/News/Grid.png": 6607,
	"./assets/font/MiSans VF.ttf": 180,
	"./assets/font/Montserrat-VariableFont_wght.ttf": 4065,
	"./assets/font/font.css": 924,
	"./assets/images/Group.png": 3525,
	"./assets/images/QRcode.png": 9296,
	"./assets/images/banner-text-vision.png": 3857,
	"./assets/images/banners-mobile.png": 2182,
	"./assets/images/banners.png": 653,
	"./assets/images/base-1.png": 1659,
	"./assets/images/base-2.png": 1808,
	"./assets/images/base-3.png": 8713,
	"./assets/images/case-1.jpeg": 3353,
	"./assets/images/case-1.png": 8276,
	"./assets/images/case-2.jpeg": 2024,
	"./assets/images/case-2.png": 3551,
	"./assets/images/case-3.jpeg": 543,
	"./assets/images/case-3.png": 9750,
	"./assets/images/case-4.png": 9721,
	"./assets/images/case-certification.jpg": 9323,
	"./assets/images/case-danshen-mulch.jpg": 9164,
	"./assets/images/close.png": 1448,
	"./assets/images/code.png": 9293,
	"./assets/images/contact.png": 4572,
	"./assets/images/corporateVision.png": 7525,
	"./assets/images/corporates.png": 1666,
	"./assets/images/crisis-back.png": 4769,
	"./assets/images/down.png": 7110,
	"./assets/images/download.png": 678,
	"./assets/images/grid1.png": 3765,
	"./assets/images/home-background.png": 5346,
	"./assets/images/home-title-opacity.png": 1966,
	"./assets/images/home-title.png": 4518,
	"./assets/images/infinite.png": 3734,
	"./assets/images/introduction-title.png": 6587,
	"./assets/images/left-line.png": 3654,
	"./assets/images/line-bottom.png": 7166,
	"./assets/images/lines.png": 8697,
	"./assets/images/logo.png": 4375,
	"./assets/images/material-banner.png": 6014,
	"./assets/images/material-title.png": 8768,
	"./assets/images/menu.png": 855,
	"./assets/images/mint.png": 1810,
	"./assets/images/new-1.png": 2248,
	"./assets/images/number-1.png": 3359,
	"./assets/images/number-2.png": 8084,
	"./assets/images/part4.png": 2897,
	"./assets/images/product-1.jpeg": 4856,
	"./assets/images/product-2.jpg": 5568,
	"./assets/images/product-3.jpeg": 7970,
	"./assets/images/product-4.jpeg": 4051,
	"./assets/images/product-5.jpg": 8195,
	"./assets/images/product-6.jpg": 2132,
	"./assets/images/product-histidine.png": 7729,
	"./assets/images/product-isoleucine.png": 5688,
	"./assets/images/product_3.png": 6151,
	"./assets/images/project-3.png": 5127,
	"./assets/images/project.png": 5075,
	"./assets/images/scientific-2.png": 6572,
	"./assets/images/scientific.png": 7157,
	"./assets/images/story-1.png": 1154,
	"./assets/images/story-2.png": 8398,
	"./assets/images/swiper3.png": 1571,
	"./assets/images/swiper4.png": 2172,
	"./assets/images/swiper5.png": 3797,
	"./assets/images/vision-title-opacity.png": 3719,
	"./assets/images/vision-title.png": 1739,
	"./assets/images/wechat.png": 8876,
	"./assets/images/wxCode.png": 7000,
	"./assets/images/wxCode2.jpg": 1756,
	"./components/AaModuleContent": 3412,
	"./components/AaModuleContent/": 3412,
	"./components/AaModuleContent/index": 3412,
	"./components/AaModuleContent/index.vue": 3412,
	"./components/AaModuleContentMobile": 254,
	"./components/AaModuleContentMobile/": 254,
	"./components/AaModuleContentMobile/index": 254,
	"./components/AaModuleContentMobile/index.vue": 254,
	"./components/BannerTitle": 1377,
	"./components/BannerTitle/": 1377,
	"./components/BannerTitle/index": 1377,
	"./components/BannerTitle/index.vue": 1377,
	"./components/BannerTitleAnimation": 1758,
	"./components/BannerTitleAnimation/": 1758,
	"./components/BannerTitleAnimation/index": 1758,
	"./components/BannerTitleAnimation/index.vue": 1758,
	"./components/BannerTitleAnimationMobile": 9736,
	"./components/BannerTitleAnimationMobile/": 9736,
	"./components/BannerTitleAnimationMobile/index": 9736,
	"./components/BannerTitleAnimationMobile/index.vue": 9736,
	"./components/BioIntelligent/BioIntelligentApplication": 6695,
	"./components/BioIntelligent/BioIntelligentApplication.vue": 6695,
	"./components/BioIntelligent/BioIntelligentPart1": 4762,
	"./components/BioIntelligent/BioIntelligentPart1.vue": 4762,
	"./components/BioIntelligent/BioIntelligentPart2": 373,
	"./components/BioIntelligent/BioIntelligentPart2.vue": 373,
	"./components/BioIntelligent/BioIntelligentPart3": 5458,
	"./components/BioIntelligent/BioIntelligentPart3.vue": 5458,
	"./components/BioIntelligent/BioIntelligentPart4": 9123,
	"./components/BioIntelligent/BioIntelligentPart4.vue": 9123,
	"./components/BioIntelligent/BioIntelligentPart5": 182,
	"./components/BioIntelligent/BioIntelligentPart5.vue": 182,
	"./components/BioIntelligent/BioIntelligentPart6": 1031,
	"./components/BioIntelligent/BioIntelligentPart6.vue": 1031,
	"./components/BioIntelligent/BioIntelligentPart7": 1862,
	"./components/BioIntelligent/BioIntelligentPart7.vue": 1862,
	"./components/Contact": 1868,
	"./components/Contact/": 1868,
	"./components/Contact/images/QRcode.png": 2370,
	"./components/Contact/images/divider.png": 2277,
	"./components/Contact/index": 1868,
	"./components/Contact/index.vue": 1868,
	"./components/ContactMobile": 8485,
	"./components/ContactMobile/": 8485,
	"./components/ContactMobile/images/QRcode.png": 5008,
	"./components/ContactMobile/images/divider.png": 9219,
	"./components/ContactMobile/index": 8485,
	"./components/ContactMobile/index.vue": 8485,
	"./components/Divider": 7185,
	"./components/Divider/": 7185,
	"./components/Divider/index": 7185,
	"./components/Divider/index.vue": 7185,
	"./components/Footer": 8433,
	"./components/Footer/": 8433,
	"./components/Footer/images/divider.png": 7664,
	"./components/Footer/index": 8433,
	"./components/Footer/index.vue": 8433,
	"./components/FooterMobile": 8333,
	"./components/FooterMobile/": 8333,
	"./components/FooterMobile/images/divider.png": 9814,
	"./components/FooterMobile/index": 8333,
	"./components/FooterMobile/index.vue": 8333,
	"./components/Header": 9852,
	"./components/Header/": 9852,
	"./components/Header/images/arrow_down.png": 9415,
	"./components/Header/images/arrow_up.png": 2204,
	"./components/Header/images/close.png": 361,
	"./components/Header/images/download.png": 5301,
	"./components/Header/images/menu.png": 1380,
	"./components/Header/index": 9852,
	"./components/Header/index.vue": 9852,
	"./components/HonorCard": 7924,
	"./components/HonorCard/": 7924,
	"./components/HonorCard/index": 7924,
	"./components/HonorCard/index.vue": 7924,
	"./components/MiNTNews/MiNTNewsDetailCom": 4131,
	"./components/MiNTNews/MiNTNewsDetailCom.vue": 4131,
	"./components/MiNTNews/MiNTNewsDetailSection": 9763,
	"./components/MiNTNews/MiNTNewsDetailSection.vue": 9763,
	"./components/MiNTNews/MiNTNewsList": 7165,
	"./components/MiNTNews/MiNTNewsList.vue": 7165,
	"./components/MiNTNews/MiNTNewsListMobile": 6999,
	"./components/MiNTNews/MiNTNewsListMobile.vue": 6999,
	"./components/MiNTNews/MiNTNewsListPreview": 7019,
	"./components/MiNTNews/MiNTNewsListPreview.vue": 7019,
	"./components/MiNTNews/MiNTNewsOverview": 4211,
	"./components/MiNTNews/MiNTNewsOverview.vue": 4211,
	"./components/MiNTNews/MiNTNewsTop": 6630,
	"./components/MiNTNews/MiNTNewsTop.vue": 6630,
	"./components/MiNTNews/NewsCardPreview": 2155,
	"./components/MiNTNews/NewsCardPreview.vue": 2155,
	"./components/MiNTProgress/MiNTProgress": 7941,
	"./components/MiNTProgress/MiNTProgress.vue": 7941,
	"./components/MobileHeader": 8341,
	"./components/MobileHeader/": 8341,
	"./components/MobileHeader/images/arrow_down.png": 7757,
	"./components/MobileHeader/images/arrow_up.png": 5126,
	"./components/MobileHeader/images/close.png": 5159,
	"./components/MobileHeader/images/download.png": 6347,
	"./components/MobileHeader/images/menu.png": 6750,
	"./components/MobileHeader/index": 8341,
	"./components/MobileHeader/index.vue": 8341,
	"./components/MouseScroll": 9535,
	"./components/MouseScroll/": 9535,
	"./components/MouseScroll/index": 9535,
	"./components/MouseScroll/index.vue": 9535,
	"./components/MouseScrollM": 5596,
	"./components/MouseScrollM/": 5596,
	"./components/MouseScrollM/index": 5596,
	"./components/MouseScrollM/index.vue": 5596,
	"./components/MouseScrollMobile": 2535,
	"./components/MouseScrollMobile/": 2535,
	"./components/MouseScrollMobile/index": 2535,
	"./components/MouseScrollMobile/index.vue": 2535,
	"./components/Propagate": 8375,
	"./components/Propagate/": 8375,
	"./components/Propagate/index": 8375,
	"./components/Propagate/index.vue": 8375,
	"./components/Swiper": 4082,
	"./components/Swiper/": 4082,
	"./components/Swiper/index": 4082,
	"./components/Swiper/index.vue": 4082,
	"./config/brandBrochure": 6691,
	"./config/brandBrochure.js": 6691,
	"./event/event": 1052,
	"./event/event.js": 1052,
	"./i18n/common/en-US": 9542,
	"./i18n/common/en-US.json": 9542,
	"./i18n/common/zh-CN": 2876,
	"./i18n/common/zh-CN.json": 2876,
	"./i18n/en-US": 7964,
	"./i18n/en-US.json": 7964,
	"./i18n/modules/navigation/en-US": 8643,
	"./i18n/modules/navigation/en-US.json": 8643,
	"./i18n/modules/navigation/zh-CN": 2693,
	"./i18n/modules/navigation/zh-CN.json": 2693,
	"./i18n/modules/news/en-US": 8298,
	"./i18n/modules/news/en-US.json": 8298,
	"./i18n/modules/news/zh-CN": 3504,
	"./i18n/modules/news/zh-CN.json": 3504,
	"./i18n/modules/pages/en-US": 3601,
	"./i18n/modules/pages/en-US.json": 3601,
	"./i18n/modules/pages/zh-CN": 7063,
	"./i18n/modules/pages/zh-CN.json": 7063,
	"./i18n/modules/products/en-US": 4141,
	"./i18n/modules/products/en-US.json": 4141,
	"./i18n/modules/products/zh-CN": 1443,
	"./i18n/modules/products/zh-CN.json": 1443,
	"./i18n/zh-CN": 8318,
	"./i18n/zh-CN.json": 8318,
	"./main": 1406,
	"./main.js": 1406,
	"./pages/AminoAcid": 2678,
	"./pages/AminoAcid/": 2678,
	"./pages/AminoAcid/index": 2678,
	"./pages/AminoAcid/index.vue": 2678,
	"./pages/AminoAcidMobile": 4636,
	"./pages/AminoAcidMobile/": 4636,
	"./pages/AminoAcidMobile/index": 4636,
	"./pages/AminoAcidMobile/index.vue": 4636,
	"./pages/BioIntelligent": 177,
	"./pages/BioIntelligent/": 177,
	"./pages/BioIntelligent/index": 177,
	"./pages/BioIntelligent/index.vue": 177,
	"./pages/BioIntelligentMobile": 6001,
	"./pages/BioIntelligentMobile/": 6001,
	"./pages/BioIntelligentMobile/index": 6001,
	"./pages/BioIntelligentMobile/index.vue": 6001,
	"./pages/CorporateVision": 3201,
	"./pages/CorporateVision/": 3201,
	"./pages/CorporateVision/index": 3201,
	"./pages/CorporateVision/index.vue": 3201,
	"./pages/CorporateVisionMobile": 5979,
	"./pages/CorporateVisionMobile/": 5979,
	"./pages/CorporateVisionMobile/index": 5979,
	"./pages/CorporateVisionMobile/index.vue": 5979,
	"./pages/Home": 7437,
	"./pages/Home/": 7437,
	"./pages/Home/index": 7437,
	"./pages/Home/index.vue": 7437,
	"./pages/HomeMobile": 3899,
	"./pages/HomeMobile/": 3899,
	"./pages/HomeMobile/index": 3899,
	"./pages/HomeMobile/index.vue": 3899,
	"./pages/KnotWeed": 3410,
	"./pages/KnotWeed/": 3410,
	"./pages/KnotWeed/index": 3410,
	"./pages/KnotWeed/index.vue": 3410,
	"./pages/KnotWeedMobile": 4272,
	"./pages/KnotWeedMobile/": 4272,
	"./pages/KnotWeedMobile/index": 4272,
	"./pages/KnotWeedMobile/index.vue": 4272,
	"./pages/MiNTNews/MiNTNews": 4081,
	"./pages/MiNTNews/MiNTNews.vue": 4081,
	"./pages/MiNTNews/MiNTNewsDetail": 3145,
	"./pages/MiNTNews/MiNTNewsDetail.vue": 3145,
	"./pages/MiNTNewsMobile/MiNTNewsDetailMobile": 4583,
	"./pages/MiNTNewsMobile/MiNTNewsDetailMobile.vue": 4583,
	"./pages/MiNTNewsMobile/MiNTNewsMobile": 6900,
	"./pages/MiNTNewsMobile/MiNTNewsMobile.vue": 6900,
	"./pages/NewMaterial": 5679,
	"./pages/NewMaterial/": 5679,
	"./pages/NewMaterial/components/MaterialProductCards": 6875,
	"./pages/NewMaterial/components/MaterialProductCards.vue": 6875,
	"./pages/NewMaterial/index": 5679,
	"./pages/NewMaterial/index.vue": 5679,
	"./pages/NewMaterialMobile": 8201,
	"./pages/NewMaterialMobile/": 8201,
	"./pages/NewMaterialMobile/index": 8201,
	"./pages/NewMaterialMobile/index.vue": 8201,
	"./pages/Vision": 1315,
	"./pages/Vision/": 1315,
	"./pages/Vision/VisionModule5": 7140,
	"./pages/Vision/VisionModule5.vue": 7140,
	"./pages/Vision/images/banner1.png": 5975,
	"./pages/Vision/images/banner2_1.jpg": 8680,
	"./pages/Vision/images/banner2_2.jpg": 5015,
	"./pages/Vision/images/banner2_3.jpg": 7274,
	"./pages/Vision/images/banner2_4.jpg": 3993,
	"./pages/Vision/images/banner3_list_info.png": 3599,
	"./pages/Vision/images/banner_title.png": 9155,
	"./pages/Vision/images/book_icon.png": 8245,
	"./pages/Vision/images/down.png": 4958,
	"./pages/Vision/images/grid.png": 7638,
	"./pages/Vision/images/module5_img1.jpeg": 3637,
	"./pages/Vision/images/module5_img2.png": 515,
	"./pages/Vision/images/module5_img3.jpeg": 2459,
	"./pages/Vision/images/module5_img4.png": 2181,
	"./pages/Vision/images/process.png": 6219,
	"./pages/Vision/images/semicolon_icon.png": 927,
	"./pages/Vision/images/trend.png": 2533,
	"./pages/Vision/index": 1315,
	"./pages/Vision/index.vue": 1315,
	"./pages/VisionMobile": 3754,
	"./pages/VisionMobile/": 3754,
	"./pages/VisionMobile/CrisisCard": 7954,
	"./pages/VisionMobile/CrisisCard/": 7954,
	"./pages/VisionMobile/CrisisCard/index": 7954,
	"./pages/VisionMobile/CrisisCard/index.vue": 7954,
	"./pages/VisionMobile/VisionModule5": 8222,
	"./pages/VisionMobile/VisionModule5.vue": 8222,
	"./pages/VisionMobile/images/banner1.png": 4445,
	"./pages/VisionMobile/images/banner2_1.jpg": 9030,
	"./pages/VisionMobile/images/banner2_2.jpg": 9182,
	"./pages/VisionMobile/images/banner2_3.jpg": 3076,
	"./pages/VisionMobile/images/banner2_4.jpg": 3887,
	"./pages/VisionMobile/images/banner3_list_info.png": 7665,
	"./pages/VisionMobile/images/banner_title.png": 5241,
	"./pages/VisionMobile/images/book_icon.png": 9067,
	"./pages/VisionMobile/images/down.png": 3820,
	"./pages/VisionMobile/images/grid.png": 5560,
	"./pages/VisionMobile/images/module5_img1.jpeg": 8007,
	"./pages/VisionMobile/images/module5_img2.png": 6021,
	"./pages/VisionMobile/images/module5_img3.jpeg": 9569,
	"./pages/VisionMobile/images/module5_img4.png": 6563,
	"./pages/VisionMobile/images/process.png": 1493,
	"./pages/VisionMobile/images/semicolon_icon.png": 2765,
	"./pages/VisionMobile/images/trend.png": 9603,
	"./pages/VisionMobile/index": 3754,
	"./pages/VisionMobile/index.vue": 3754,
	"./postcss.config": 9204,
	"./postcss.config.js": 9204,
	"./router": 9325,
	"./router/": 9325,
	"./router/index": 9325,
	"./router/index.js": 9325,
	"./style/common.less": 1222,
	"./style/variable.less": 4403,
	"./utils": 1981,
	"./utils/": 1981,
	"./utils/colorShortcode": 5479,
	"./utils/colorShortcode.js": 5479,
	"./utils/directives": 264,
	"./utils/directives/": 264,
	"./utils/directives/index": 264,
	"./utils/directives/index.js": 264,
	"./utils/directives/intersect": 8457,
	"./utils/directives/intersect.js": 8457,
	"./utils/index": 1981,
	"./utils/index.js": 1981,
	"./utils/isPc": 8260,
	"./utils/isPc.js": 8260,
	"./utils/language": 4875,
	"./utils/language.js": 4875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;